import { render } from "./tcQrCode.vue?vue&type=template&id=b70709ee"
import script from "./tcQrCode.vue?vue&type=script&lang=js"
export * from "./tcQrCode.vue?vue&type=script&lang=js"

import "./tcQrCode.vue?vue&type=style&index=0&id=b70709ee&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__